<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate() {
    const { mode } = this.$route.query
    mode && document.body.classList.add(mode);
  }
};
</script>